import React from 'react';
import { PageContainer } from '@ant-design/pro-layout';
import { Tabs } from 'antd';
import { IAppComponentProps } from '../../components';
import TabPane from 'antd/es/tabs/TabPane';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import UserGuideGroupManagement from './UserGuideGroupManagement';
import UserGuideContentManagement from './UserGuideContentManagement';

export type Translation = {
    languageCode: string;
    phraseId: string;
    translation: string;
};

export type UserGuideGroupQuery = {
    userGuideGroupId?: number | null;
    userGuideGroupNamePhraseId: string;
    sortOrder: number;
    translations: Translation[];
};


const UserGuideManagement = ({ intl, currentUser }: IAppComponentProps) => {
    return (
        <PageContainer>
            <Tabs defaultActiveKey="1">
                <TabPane tab="User Guide Groups" key="1">
                    <UserGuideGroupManagement intl={intl} currentUser={currentUser} />
                </TabPane>
                <TabPane tab="User Guides" key="2">
                    <UserGuideContentManagement intl={intl} currentUser={currentUser} />
                </TabPane>
            </Tabs>
        </PageContainer>
    );
};

export default UserGuideManagement;
